namespace GeniuzPOS.PosShift {
    export interface PsPriceOverrideTranRow {
        Id?: number;
        DocNo?: string;
        PluCode?: string;
        PluDesc?: string;
        PosId?: string;
        Qty?: number;
        UnitPrice?: number;
        OverridePrice?: number;
        PriceOverrideId?: number;
        CashierId?: string;
        MgrCashierId?: string;
        CreateBy?: string;
        CreateDate?: string;
    }

    export namespace PsPriceOverrideTranRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'PosShift.PsPriceOverrideTran';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PosId = "PosId",
            Qty = "Qty",
            UnitPrice = "UnitPrice",
            OverridePrice = "OverridePrice",
            PriceOverrideId = "PriceOverrideId",
            CashierId = "CashierId",
            MgrCashierId = "MgrCashierId",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate"
        }
    }
}
